import type { FC } from 'react';
export const PvSheetGrabber: FC = () => <span className="h-1 w-10 rounded-full bg-white/30" />;
